export enum Tips {
    ACTIVITIES_VIEW = 'ACTIVITIES_SELECTION',
    TIME_RANGE_SELECTION = 'TIME_RANGE_SELECTION',
}
